import { useContext } from "react"
import { stateContext } from "./ctx"
import { icons } from "./icons"

const Love = () => {
    const {schema,bgColor,hue,setSession} = useContext(stateContext)

    const save = () => {
        let saved = localStorage.getItem('MESHERSAVES')
        saved = saved ? JSON.parse(saved) : {}
        const newOb = {schema,bgColor,hue}
        saved[Date.now()] = newOb
        localStorage.setItem('MESHERSAVES',JSON.stringify(saved))
        setSession(Date.now())
    }

    return <div onClick={save} className='btn'>{icons.heart}</div>
}

export default Love;